import { useHead } from '@vueuse/head'
import { computed, ref, watch } from 'vue'

import { useGlobalSeoStore } from '@/stores/globalSeo'

import type { GTMDataLayerForms, ModalPopup, RisWarningPopUp } from '@/stores/globalSeo.types'

const defaultRobotsMeta = ref('index, follow')

export const useGlobalSeoMetaHandler = (overrideFlag = false) => {
  const robotsMetaContent = ref(overrideFlag ? 'noindex, nofollow' : defaultRobotsMeta.value)

  useHead({
    meta: [
      {
        name: 'robots',
        content: robotsMetaContent.value
      }
    ]
  })

  // Watch the override flag to dynamically adjust robots meta
  watch(
    () => overrideFlag,
    (newValue) => {
      robotsMetaContent.value = newValue ? 'noindex, nofollow' : defaultRobotsMeta.value
    },
    { immediate: true }
  )
}

export const useSeoGtmScript = () => {
  const globalSeoStore = useGlobalSeoStore()
  return globalSeoStore.getGlobalSeoData?.global_seo?.[0]?.fields?.gtm_script || ''
}

export const useFooterData = () => {
  const globalSeoStore = useGlobalSeoStore()
  return computed(() => globalSeoStore.getGlobalSeoData?.global_footer?.[0]?.fields || '')
}

export const useModalPopup = () => {
  const globalSeoStore = useGlobalSeoStore()
  return computed((): ModalPopup => globalSeoStore.getGlobalSeoData?.modal_popup || {})
}

export const gtmDataLayerTrackForms = (data: GTMDataLayerForms) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(<GTMDataLayerForms>data)
}

export const useRiskWarningPopUp = () => {
  const globalSeoStore = useGlobalSeoStore()
  return computed((): RisWarningPopUp => globalSeoStore.getGlobalSeoData.risk_warning_popup || {})
}

export const useTrustPilotWidget = () =>
  useHead({
    script: [
      {
        src: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
        async: true
      }
    ]
  })
